import React, { useContext, useState } from "react"
import _ from "lodash"
import { Link } from "react-router-dom"
import { useParams, useNavigate } from "react-router-dom"

import { useQuery, useMutation } from "@apollo/client"
import { Formik, Form } from "formik"

// Prime
import { PickList } from "primereact/picklist"
import { Button } from "primereact/button"
import { LoaderMedium } from "../../components/Loaders"

// Styles
import styles from "../../styles/Form.module.css"
import formStyles from "../../styles/Form-ProgramEdit.module.css"

// Context
import { UserContext } from "../../context/userContext"

// ico
import { MdAccountCircle as IcoParticipant } from "react-icons/md"

// Queries
import { LOAD_ASSIGN_FORM, ASSIGN_STAFF, GET_USERS } from "./queries"

export default function ProgramAssign() {
  const userCtx = useContext(UserContext)
  const { idStaff } = useParams()

  const navigate = useNavigate()
  const [source, setSource] = useState([])
  const [target, setTarget] = useState([])

  const onChange = (event) => {
    setSource(event.source)
    setTarget(event.target)
  }

  const { data, loading } = useQuery(LOAD_ASSIGN_FORM, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
      idStaff: idStaff,
      condiction: false,
    },
    onCompleted: (data) => {
      setSource(data.loadingAvailable)
      setTarget(data.loadingSelected)
    },
    fetchPolicy: "no-cache",
  })

  const [assignStaff, { loadingMutation }] = useMutation(ASSIGN_STAFF)

  if (loading) return <LoaderMedium />
  if (loadingMutation) return <LoaderMedium />

  const itemTemplate = (item) => {
    return (
      <div className={formStyles.participantItem}>
        <div className={formStyles.imageContainer}>
          <IcoParticipant />
        </div>

        <div className={formStyles.participantListDetail}>
          <h5 className={formStyles.participantName}>
            {item.participant_name_last + " , " + item.participant_name_first}
          </h5>
          <i className={`pi pi-mail ${formStyles.participantCategoryIcon}`}></i>
          <span className="participantCategory">
            {item.participant_name_preferred}
          </span>
        </div>

        <div className={formStyles.participantListAction}>
          <h6 className={formStyles.participantName}>
            ID: {item.participant_alias}
          </h6>
          <span
            className={`participantBadge status-${item.status.toLowerCase()}`}
          >
            {item.status}
          </span>
        </div>
      </div>
    )
  }

  return (
    <div>
      <h1>Assign Staff: {`${data}`}</h1>
      <Formik
        initialValues={{}}
        onSubmit={async () => {
          const pids = _.map(target, ({ pid }) => pid)
          assignStaff({
            variables: {
              staff_id: userCtx.session.user.staff_id,
              organization_id: userCtx.session.user.organization_id,
              idStaff: idStaff,
              pids,
            },
            refetchQueries: [
              {
                query: GET_USERS,
                variables: {
                  staff_id: userCtx.session.user.staff_id,
                  organization_id: userCtx.session.user.organization_id,
                },
              },
            ],
            fetchPolicy: "no-cache",
          })
          navigate("/enterprise/programs")
        }}
      >
        {(formik) => {
          return (
            <Form className={styles.form}>
              <div className={styles.field}>
                <label className={formStyles.label}>
                  Participants related to the program:
                </label>
                <div className="card">
                  <PickList
                    source={source}
                    target={target}
                    itemTemplate={itemTemplate}
                    sourceHeader="Available"
                    targetHeader="Selected"
                    sourceStyle={{ height: "342px" }}
                    targetStyle={{ height: "342px" }}
                    onChange={onChange}
                    className={styles.value}
                  ></PickList>
                </div>
              </div>

              <div className={styles.field}>
                <Button
                  label="Save"
                  icon="pi pi-check"
                  loading={formik.isSubmitting}
                  disabled={!formik.isValid}
                  type="submit"
                  className={styles.submitButton}
                />
                <Link to={`/enterprise/programs/`} className="btnBack">
                  Back
                </Link>
              </div>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}
